import axios from 'axios';
import { getConfig } from '@/config';
import { getAuthorizationToken, getIdentityAssertion } from '../claudeCodeDashboard/token';

// Same staff credentials as claudeCodeInstance, minus its 401 handler: the navbar probes /secrets/me on
// every screen, and a refusal there must not sign the operator out of every other staff screen.
export const secretsInstance = axios.create({
  baseURL: getConfig().internalApiUrl,
  timeout: 15000,
});

secretsInstance.interceptors.request.use(async (requestConfig) => {
  const token = await getAuthorizationToken();
  if (token) {
    requestConfig.headers.set('Authorization', `Bearer ${token}`);
  }
  const assertion = await getIdentityAssertion();
  if (assertion) {
    requestConfig.headers.set('x-identity-assertion', assertion);
  }
  return requestConfig;
});
